import { SupportedLocales } from '@/models/localization.model';
import { IProductLocale } from '@/models/products.model';
import { TProductSeoLocalizedFields } from '@/modules/Products/helpers/types';

export const getSeoInitialLocale = (productLocale?: IProductLocale[]) => {
  const locale =
    productLocale?.reduce((acc: { [key in SupportedLocales]: TProductSeoLocalizedFields }, item) => {
      acc[item.locale] = {
        seo_title: item.seo_title || '',
        seo_description: item.seo_description || '',
        seo_keywords: item.seo_keywords?.split(',') || [],
        seo_text: item.seo_text || '',
      };
      return acc;
    }, {} as { [key in SupportedLocales]: TProductSeoLocalizedFields }) || null;
  return { locale };
};
